<template>
		<div class="container">
			<div class="columns is-vcentered">
				<div class="column has-text-centered">
					<h1 class="title">404 Page Not Found</h1>
					<p class="subtitle">The page you're looking for no longer exist.</p>
					<span class="button is-info" @click="goToPage('compliances')">Home</span>
					<span class="button is-info" @click="goToPage('requests')">Jobs</span>
				</div>
			</div>
		</div>
</template>
<script>
import router from '../../../router'

export default {
	name: 'page-not-found',
	methods: {
		goToPage(tab) {        
				var routeName = tab;
				
				// push to welcome page when 'Home' is pressed.
				if(tab === 'compliances'){
					routeName = routeName+'/welcome';
					VueStore.dispatch('nav/setVariables', 
							{
									key: 'activeHeaderTab',
									value: tab
							}
					)
					VueStore.dispatch('nav/setVariables', 
							{
									key: 'activeHeaderDisplayName',
									value: 'Home'
							}
					)
				} else {
					VueStore.dispatch('nav/setVariables', 
							{
									key: 'activeHeaderTab',
									value: tab
							}
					)
					VueStore.dispatch('nav/setVariables', 
							{
									key: 'activeHeaderDisplayName',
									value: 'Jobs'
							}
					)
				}
				router.push({path: `/${routeName}`});
		},
	}
}
</script>
<style scoped>
.container{
	margin-top: 50px;
}
</style>